import PromoteApplicationModule from "./PromoteApplicationModule";

export default PromoteApplicationModule;